import { __assign } from "tslib";
import { ONE_KILO_BYTE, validateAndBuildConfiguration } from '@datadog/browser-core';
import { buildEnv } from '../boot/buildEnv';
/**
 * arbitrary value, byte precision not needed
 */
export var DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT = 32 * ONE_KILO_BYTE;
export function validateAndBuildLogsConfiguration(initConfiguration) {
    var baseConfiguration = validateAndBuildConfiguration(initConfiguration, buildEnv);
    if (!baseConfiguration) {
        return;
    }
    return __assign(__assign({}, baseConfiguration), { forwardErrorsToLogs: !!initConfiguration.forwardErrorsToLogs, requestErrorResponseLengthLimit: DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT });
}
//# sourceMappingURL=configuration.js.map